/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import React, { useEffect, useState } from 'react';
import Select from 'react-select';

import { Typography } from '@material-tailwind/react';


export interface SelectOption {
    value: string;
    label: string;
    icon?: React.ReactNode;
}

interface FormTagInputProps {
    id: string;
    value: string | SelectOption[] | null;
    setValue: (value: any) => void;
    label: string;
    isMulti?: boolean;
    labelClass?: string;
    labelColor?: string;
    wrapperClass?: string;
    placeholder: string;
    options: SelectOption[];
    theme?: 'dark' | 'light';
    isClearable?: boolean;
}

export const FormTagInput: React.FC<FormTagInputProps> = ({
    id,
    value,
    setValue,
    label,
    labelClass,
    labelColor,
    wrapperClass,
    theme = 'dark',
    options,
    placeholder,
    isMulti,
    isClearable = true
}) => {
    const [opt_value, setOptValue] = useState<SelectOption | SelectOption[] | null>(null);

    useEffect(() => {
        if (isMulti && Array.isArray(value)) {
            setOptValue(value);
            return;
        }

        if (typeof value === 'string') {
            if (value) {
                setOptValue(options.find(option => option.value === value) || null);
            } else {
                setOptValue(null);
            }
        }
    }, [value, options, isMulti]);

    // Custom styles for react-select
    const customStylesDark = {
        control: (base: any) => ({
            ...base,
            borderRadius: '5px',
            borderWidth: '2px',
            borderColor: '#D9D9D9',
            color: 'black',
            padding: '0.2rem',
            '&:hover': {
                borderWidth: '2px',
                borderColor: '#cbd5e0',
            },
        }),
        option: (base: any) => ({
            ...base,
            color: 'black',
        }),
        valueContainer: (base: any) => ({
            ...base,
            padding: '0',
        }),
        multiValue: (base: any) => ({
            ...base,
            backgroundColor: '#fff',
            paddingLeft: '5px',
            color: '#000',
            borderRadius: '4px',
            borderWidth: '2px',
        }),
        multiValueLabel: (base: any) => ({
            ...base,
            color: '#000',
        }),
        multiValueRemove: (base: any) => ({
            ...base,
            color: 'white',
            ':hover': {
                backgroundColor: '#f87171',
                color: 'white',
            },
        }),
    };

    const customStylesLight = {
        control: (base: any) => ({
            ...base,
            borderWidth: "0",
            borderColor: "transparent",
            outline: "none",
            boxShadow: "none",
            color: "black",
            padding: "0",
            margin: "0",
            "&:hover": {
                borderWidth: "0",
                borderColor: "transparent",
            },
        }),
        indicatorSeparator: (base: any) => ({
            ...base,
            display: "none",
        }),
        indicatorContainer: (base: any) => ({
            ...base,
            padding: "0",
            margin: "0",
        }),
        valueContainer: (base: any) => ({
            ...base,
            padding: "0",
            margin: "0",
        }),
        placeholder: (base: any) => ({
            ...base,
            color: "#6a6a6a",
            padding: "0",
            margin: "0",
        }),
        option: (base: any) => ({
            ...base,
            color: "black",
            display: "flex",
            alignItems: "center",
            gap: "8px",
        }),
        multiValue: (base: any) => ({
            ...base,
            backgroundColor: "transparent",
            border: "1px solid #D9D9D9",
            paddingLeft: "0px",
            color: "#6a6a6a",
            borderRadius: "4px",
            borderWidth: "2px",
        }),
        multiValueLabel: (base: any) => ({
            ...base,
            paddingLeft: "0px",
            color: "#333332",
        }),
        multiValueRemove: (base: any) => ({
            ...base,
            color: "#000000",
            ":hover": {
                backgroundColor: "#f87171",
                color: "white",
            },
        }),
    };

    return (
        <div className={wrapperClass || "mb-6 space-y-1.5"}>
            <div className="flex justify-between">
                { label ?
                   <Typography
                        as="label"
                        htmlFor={id}
                        type="small"
                        color="default"
                        className={`${labelClass ? labelColor : 'font-semibold'} ${labelColor ? labelColor : 'text-black'}`}
                    >
                        {label}
                    </Typography>
                    : null
                }
            </div>
            <Select
                id={id}
                value={opt_value}
                onChange={(newValue) => {
                    if (isMulti) {
                        //@ts-ignore
                        setOptValue(newValue);
                        //@ts-ignore
                        setValue(newValue);
                    } else {
                        //@ts-ignore
                        setOptValue(newValue);
                        //@ts-ignore
                        setValue(newValue?.value);
                    }
                }}
                options={options}
                isMulti={isMulti}
                className=''
                placeholder={placeholder}
                styles={theme === 'dark' ? customStylesDark : customStylesLight}
                formatOptionLabel={(option: SelectOption) => (
                    <div className="flex items-center gap-2">
                        {option?.icon}
                        <span>{option.label}</span>
                    </div>
                )}
                isClearable={isClearable}
            />
        </div>
    );
};

export default FormTagInput;
